import AccountChangePasswordForm from "app/features/authentication/templates/AccountChangePasswordForm";
import { useLocalSearchParams } from "expo-router";

export default function AccountPasswordSetScreen() {
  const { email, token } = useLocalSearchParams();

  return (
    <AccountChangePasswordForm
      type="initial-set"
      email={email as string}
      token={token as string}
    />
  );
}
